import 'cookieconsent'

export default function() {

    function importScript(src, id, onload) {
        const script = document.createElement('script')
        script.src = src
        script.id = id || ''
        script.async = true
        script.type = 'text/javascript'
        if (onload) { script.onload = onload }
        document.body.appendChild(script)
    }

    // Hotjar tracking code: https://app.vivifyscrum.com/boards/18138/sprint-backlog/57845/AAB4-72
    (function(h, o, t, j, a, r) {
        h.hj = h.hj || function() {
            (h.hj.q = h.hj.q || []).push(arguments)
        };
        h._hjSettings = { hjid: 681946, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

    // Hubspot tracker: https://github.com/archiidev/issue/issues/476
    importScript('//js.hs-scripts.com/3937313.js', 'hs-script-loader');

    // Analytics + Tag manager code
    // importScript('https://www.googletagmanager.com/gtag/js?id=UA-108054246-1')
    // window.dataLayer = window.dataLayer || [];

    // function gtag() { dataLayer.push(arguments) }
    // gtag('js', new Date())
    // gtag('config', 'UA-108054246-1');

    // Google Tag Manager: https://github.com/archiidev/issue/issues/475
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-P5PRJXC')

    // Facebook Pixel Code
    ! function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1643275559073475');
    fbq('track', 'PageView');

    ! function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '170592076919016');
    fbq('track', 'PageView');

    window.cookieconsent.initialise({
        palette: {
            popup: {
                background: '#237afc'
            },
            button: {
                text: '#237afc',
                background: '#fff'
            }
        },
        content: {
            link: 'Learn more',
            dismiss: 'I accept',
            href: 'https://bysafeonline.com/connectid-datamapper-resources',
            message: 'This website uses cookies. By clicking the accept button or by continuing to browse the website you are agreeing to our use of cookies.'
        }
    })

}



// WEBPACK FOOTER //
// ./apps/assets/js/trackers.js